import React from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import styles from '../../css/Header.module.css';

export const AssumeUserModal = ({
  isShowingModal,
  handleClose,
  handleSave,
  onChange,
  txtAssumeUser,
  type,
}) => (
  <Modal
    className={styles.assumeUserModal}
    show={isShowingModal}
    onHide={handleClose}
  >
    <Modal.Header className={styles.modalHeader} closeButton></Modal.Header>
    <Modal.Body className={styles.modalBody}>
      Enter Assumed User ID
      <Form className={styles.form}>
        <Form.Row>
          <Form.Control
            type={type || 'text'}
            className={styles.textInput}
            value={txtAssumeUser}
            onChange={onChange}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSave();
              }
            }}
          />
        </Form.Row>
      </Form>
    </Modal.Body>
    <Modal.Footer className={styles.modalFooter}>
      <Button size="lg" block className={styles.button} onClick={handleSave}>
        SUBMIT
      </Button>
    </Modal.Footer>
  </Modal>
);

export const RemoveAssumeUserModal = ({
  handleCloseUnassume,
  handleCloseUnassumeNo,
  isShowingModalUnassume,
  assumeUserVal,
}) => (
  <Modal
    className={styles.removeAssumeUserModal}
    show={isShowingModalUnassume}
    onHide={handleCloseUnassumeNo}
  >
    <Modal.Header className={styles.modalHeader} closeButton></Modal.Header>
    <Modal.Body className={styles.removeAssumeUserBody}>
      Do you want to release this User?
      <p className={styles.removeAssumeUserName}>{assumeUserVal}</p>
    </Modal.Body>
    <Modal.Footer className={styles.modalFooter}>
      <Button
        size="lg"
        block
        className={styles.button_no}
        onClick={handleCloseUnassumeNo}
      >
        NO
      </Button>
      <Button
        size="lg"
        block
        className={styles.button_yes}
        onClick={handleCloseUnassume}
      >
        YES
      </Button>
    </Modal.Footer>
  </Modal>
);
